module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/pearsall-800.7a6fd9687fe8d93c.jpg"+" 800w",
        images: [{path: "https://static.sniffspot.com/packs/img/pearsall-800.7a6fd9687fe8d93c.jpg",width: 800,height: 563}],
        src: "https://static.sniffspot.com/packs/img/pearsall-800.7a6fd9687fe8d93c.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/pearsall-800.7a6fd9687fe8d93c.jpg"},
        
        width: 800,
        height: 563
      }